export class LoadUnreadActions {
  static readonly type = '[Unread Actions] Load Unread Actions';
}
